import Vue from 'vue'
import router from './router'
import App from "./container/App.vue"
// import plugins from "./plugins/plugins"
import ElementUI from 'element-ui'
// import vConsole from 'vconsole'
import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(plugins);
// new vConsole();
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')